/* Color de cada zona del salón (Terraza, Salón, Barra...). Ver migración 033.
 *
 * El color sale del NOMBRE, no de la posición en la lista: así "la Terraza
 * siempre es la verde" aunque mañana se agregue otra zona antes en el abecedario.
 * Dos zonas podrían tocar el mismo color; el nombre va escrito al lado, así que
 * el color solo ayuda a ubicarlas de un vistazo.
 */
const PALETA = [
  { fuerte: '#DC2626', claro: '#FEF2F2' }, // rojo
  { fuerte: '#EA580C', claro: '#FFF7ED' }, // naranja
  { fuerte: '#CA8A04', claro: '#FEFCE8' }, // amarillo
  { fuerte: '#16A34A', claro: '#F0FDF4' }, // verde
  { fuerte: '#0891B2', claro: '#ECFEFF' }, // agua
  { fuerte: '#2563EB', claro: '#EFF6FF' }, // azul
  { fuerte: '#7C3AED', claro: '#F5F3FF' }, // morado
  { fuerte: '#DB2777', claro: '#FDF2F8' }, // rosa
];

const GRIS = { fuerte: '#9CA3AF', claro: '#F9FAFB' }; // mesas sin zona

export function colorZona(zona?: string | null) {
  if (!zona) return GRIS;
  let h = 0;
  for (const c of zona) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETA[h % PALETA.length];
}
